module.exports = __webpack_public_path__ + "static/media/todo.f4b53263.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/todo.png
// module id = 190
// module chunks = 0